/**
 * Shared CRM field validation for leads, contacts, accounts, and deals.
 */

const ALLOWED_NAME_EXTRA = new Set([
  " ",
  ".",
  "'",
  "\u2019", // typographic apostrophe (Word / macOS paste)
  "-",
  "&",
  "(",
  ")",
  ",",
  "/",
  "+",
]);

export const NAME_SPECIAL_CHAR_MESSAGE =
  "Special characters are not allowed. Use letters, numbers, spaces, and common punctuation (hyphen, apostrophe, period, &, parentheses, comma, /, +).";

export const EMAIL_DUPLICATE_MESSAGE =
  "This email is already used by another lead, contact, or account.";

export function nameHasSpecialCharacters(value) {
  if (value == null) return false;
  const text = String(value).trim();
  if (!text) return false;
  for (const ch of text) {
    if (/[0-9A-Za-z]/.test(ch) || ALLOWED_NAME_EXTRA.has(ch)) continue;
    // Allow other unicode letters (e.g. accented names)
    if (/\p{L}/u.test(ch)) continue;
    return true;
  }
  return false;
}

/** Returns an error message or null. */
export function validatePersonOrEntityName(value, label = "Name") {
  if (value == null || String(value).trim() === "") return null;
  if (nameHasSpecialCharacters(value)) {
    return `${label}: ${NAME_SPECIAL_CHAR_MESSAGE}`;
  }
  return null;
}

/**
 * Pull a user-facing message from an API error (email uniqueness / name rules).
 */
export function getCrmValidationErrorMessage(error) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return detail[0].msg;
  return null;
}
